<template>
    <div class="position-relative d-flex flex-column h-100" :style="step !== 2 ? 'display: none !important;': ''">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-left donation-back-icon"
            viewBox="0 0 16 16"
            @click="backStep"
        >
            <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
            />
        </svg>
        <div class="flex-grow-1">
            <h2 class="donation-title text-center mb-3">Credit Card</h2>
            <div class="donation-desc mb-4">
                Please provide your card details to continue with your
                donation.This card will be charged.
            </div>
            <div id="cardNumber" class="mb-3 tilled-field"></div>
            <div class="row no-gutters">
                <div class="col-6 pr-1">
                    <div id="cardExp" class="mb-3 tilled-field"></div>
                </div>
                <div class="col-6 pl-1">
                    <div id="cardCvv" class="mb-3 tilled-field"></div>
                </div>
            </div>
        </div>
        <button
                id="submit"
                disabled
                class="btn w-100 ok-btn mt-3">Continue</button>
    </div>
</template>

<script>
import DibbleJs from "@/dibble";

export default {
    name: 'CreditCard',
    props: {
        donationData: {
            type: Object,
            default: () => ({}),
        },
        donationForm: {
            type: Object,
            default: () => ({}),
        },
        step: {
            type: Number,
            default: 2,
        },
    },
    data() {
        return {
            tilled: null,
            tilledForm: null,
        };
    },
    mounted() {
        let tilledScript = document.createElement('script')
        tilledScript.setAttribute('src', 'https://js.tilled.com/v2')
        document.head.appendChild(tilledScript)

        setTimeout(() => {
            this.initTilled()
        }, 3000)
    },
    methods: {
        backStep() {
            this.$emit('changeStep', 1);
        },
        async confirmPayment(secret, phone_number) {
            if (parseInt(this.donationForm.step1.donationType) === 2) {
                console.log('Creating monthly subscription payment...')
                const params = {
                    type: 'card',
                    billing_details:
                        {
                            name: `${this.donationForm.step3.firstName} ${this.donationForm.step3.lastName}`,
                            email: this.donationForm.step3.email,
                            phone: phone_number,
                            address: {
                                city: this.donationForm.step4.city,
                                country: this.donationForm.step4.country,
                                street: this.donationForm.step4.address,
                                street2: this.donationForm.step4.address2,
                                zip: this.donationForm.step4.zipCode,
                                state: (this.donationForm.step4.country.toLowerCase() == "us" ? this.donationForm.step4.state : 'XX'),
                            },
                        },
                };

                try
                {
                    const paymentMethod = await this.tilled.createPaymentMethod(params);
                    const paymentMethodId = paymentMethod.id;
                    console.log("Successful payment.");
                    console.log(JSON.stringify(paymentMethod));

                    this.$emit('checkMonthlyPaymentStatus', {
                        secret,
                        paymentMethodId,
                    })
                }
                catch (error)
                {
                    console.log("Failed to create subscription.");
                    console.log(error);

                    DibbleJs.toastErrorMessage(error)
                    DibbleJs.hideLoader()
                }
            } else {
                console.log('Creating one time payment...')
                const params = {
                    payment_method: {
                        billing_details: {
                            name: `${this.donationForm.step3.firstName} ${this.donationForm.step3.lastName}`,
                            email: this.donationForm.step3.email,
                            phone: phone_number,
                            address: {
                                city: this.donationForm.step4.city,
                                country: this.donationForm.step4.country,
                                street: this.donationForm.step4.address,
                                street2: this.donationForm.step4.address2,
                                zip: this.donationForm.step4.zipCode,
                                state: (this.donationForm.step4.country.toLowerCase() == "us" ? this.donationForm.step4.state : 'XX'),
                            },
                        },
                    }
                }

                try {
                    const payment = await this.tilled.confirmPayment(secret, params);
                    console.log('Successful payment');
                    console.log(payment)
                    this.$emit('checkPaymentStatus', secret)
                } catch (e) {
                    console.log('Failed to confirm payment');
                    console.log(e)
                    DibbleJs.toastErrorMessage(e)
                    DibbleJs.hideLoader()
                }
            }
        },
        async initTilled() {
            this.tilled = new window.Tilled(this.donationData.public_key, this.donationData.account_id, { sandbox: this.donationData.is_sandbox });

            this.form = await this.tilled.form({ payment_method_type: 'card' });

            // Style a Form Field
            const fieldOptions = {
                styles: {
                    base: {
                        fontFamily: 'Helvetica Neue, Arial, sans-serif',
                        fontWeight: '400',
                        fontSize: '16px',
                        background: 'none',
                        color: '#7c7c7a',
                        paddingInline: '16px',
                        width: '100%',
                        border: '1px solid #7c7c7a',
                        borderRadius: '8px',
                        height: '30px',
                    },
                    invalid: {
                        ':hover': {
                            textDecoration: 'underline dotted red',
                        },
                        color: 'red',
                    },
                    valid: {
                        color: '#00BDA5',
                    },
                },
            };

            this.form.createField('cardNumber', {...fieldOptions, placeholder: 'Card num'}).inject('#cardNumber');
            this.form.createField('cardExpiry', {...fieldOptions, placeholder: 'Card exp'}).inject('#cardExp');
            this.form.createField('cardCvv', {...fieldOptions, placeholder: 'CVV'}).inject('#cardCvv');

            await this.form.build();

            const cardSubmitButton = document.getElementById('submit')
            cardSubmitButton.addEventListener('click', () => {
                this.submit()
            })

            this.form.on("validation", (event) => {
                if (event.field) {
                    event.field.element.classList.remove('success', 'error')
                    event.field.element.classList.add(event.field.valid ? 'success' : 'error')
                }

                const cardSubmitButton = document.getElementById('submit')
                cardSubmitButton.disabled = !this.form.valid
            });
        },
        submit() {
            this.$emit('setTilled', this.tilled);
            this.$emit('changeStep', 3);
        },
    },
};
</script>
<style scoped>
.tilled-field {
    border: 1px solid #7c7c7a;
    border-radius: 8px;
    padding: 5px;
    height: 35px;
}
</style>
